@if (mode) {
  @if (iconOnly) {
    <span
      class="mode-pill mode-pill--icon-only"
      [class.mode-pill--mos]="mode === UserProcessMode.MOS"
      [class.mode-pill--post]="mode === UserProcessMode.POST"
      [matTooltip]="'COMMON.USER_PROCESS_MODES.' + mode | translate"
      matTooltipClass="universalTooltip">
      <mat-icon fontSet="material-icons-outlined">{{ modeIcon }}</mat-icon>
    </span>
  } @else {
    <span
      class="mode-pill"
      [class.mode-pill--mos]="mode === UserProcessMode.MOS"
      [class.mode-pill--post]="mode === UserProcessMode.POST">
      {{ 'COMMON.USER_PROCESS_MODES.' + mode | translate }}
    </span>
  }
}
